<div class="t-popup popup-patientDetails" style="display: block">
  <div class="t-popup-close"></div>

  <div class="t-popup-frame" [ngClass]="export ? 'mrg' : ''">
    <div class="t-popup-body">
      <button class="t-btn-popup-close" aria-label="close popup" (click)="closed.emit()"></button>

      <div class="login-form">
        <div *ngIf="loginService.loginError" class="strong">{{ loginService.loginError }}</div>
        <div
          class="login-form-row"
          *ngIf="!loginService.getCode && (loginService.requireExamLogon || !loginService.localServer)"
        >
          <input
            class="login-form-field focusOnParent"
            type="text"
            placeholder="User Name"
            aria-label="user name"
            [(ngModel)]="user"
            autocomplete="off"
            (keyup.enter)="checkLogin()"
            (keyup)="clean()"
          />
          <i class="login-form-icon icon-userName"></i>
        </div>

        <div
          class="login-form-row"
          *ngIf="!loginService.getCode && (loginService.requireExamLogon || !loginService.localServer)"
        >
          <input
            class="login-form-field focusOnParent"
            [type]="hidepw ? 'password' : 'text'"
            placeholder="Password"
            aria-label="password"
            [(ngModel)]="pw"
            (keyup.enter)="checkLogin()"
            (keyup)="clean()"
            autocomplete="off"
            (focus)="typed = true"
          />
          <i
            class="login-form-icon {{
              !typed ? 'icon-password' : hidepw ? 'icon-openpw' : 'icon-closepw'
            }}"
            (click)="hidepw = !hidepw"
          ></i>
        </div>

        <!-- =============== Login for Edit (Start) =============== -->
        <input
          *ngIf="
            signatureService.isExamSigned(examService.examObject) &&
            !hideButton &&
            (loginService.requireExamLogon || !loginService.localServer) &&
            !search &&
            !newexam
          "
          type="submit"
          class="login-form-submit t-btn-grad"
          (keyup.enter)="checkLogin(true); examService.isLoginForEdit = true"
          value="Login for Edit"
          (click)="showSignEditAlert=true "
        />
        <!-- =============== Login for Edit (End) =============== -->

        <!-- =============== Login (Start) =============== -->
        <input
          *ngIf="
            (!signatureService.isExamSigned(examService.examObject) || newexam) &&
            !hideButton &&
            (loginService.requireExamLogon || !loginService.localServer) &&
            !search
          "
          type="submit"
          class="login-form-submit t-btn-grad"
          (keyup.enter)="examService.isLoginForEdit = false; checkLogin()"
          value="Login"
          (click)="examService.isLoginForEdit = false; checkLogin()"
        />
        <!-- =============== Login (End) =============== -->

        <!-- =============== Edit for Edit As (Start) =============== -->
        <input
          type="submit"
          class="login-form-submit t-btn-grad"
          (keyup.enter)="examService.isLoginForEdit = true; loginAsCurrentUser(true)"
          value="Login for Edit {{ loginService.username }}"
          (click)="showSignEditAlert=true "
          *ngIf="
            signatureService.isExamSigned(examService.examObject) &&
            !loginService.requireExamLogon &&
            loginService.localServer &&
            !export &&
            !hideButton &&
            !newexam
          "
        />
        <!-- =============== Edit for Edit As (End) =============== -->

        <!-- =============== Edit As (Start) =============== -->
        <input
          type="submit"
          class="login-form-submit t-btn-grad"
          (keyup.enter)="loginService.loginAsCurrentUser()"
          value="Edit as {{ loginService.username }}"
          (click)="hideButton = true; loginService.loginAsCurrentUser()"
          *ngIf="
            (!signatureService.isExamSigned(examService.examObject) || newexam) &&
            !loginService.requireExamLogon &&
            loginService.localServer &&
            !export &&
            !hideButton
          "
        />
        <!-- =============== Edit As (End) =============== -->

        <br />

        <!-- =============== View Only (Start) =============== -->
        <!-- *ngIf="
            (!newexam && !export && signatureService.isExamSigned(examService.examObject)) || search
          " -->
        <input
          *ngIf="
            (!newexam && !export) || search
          "
          type="submit"
          class="login-form-submit t-btn-grad"
          value="VIEW ONLY"
          (click)="examService.isSignAndPrint = false; viewonly.emit()"
          style="margin-top: 1em"
        />
        <!-- =============== View Only (End) =============== -->

        <div class="login-form-row" *ngIf="loginService.exportLoading">
          <span>Downloading...</span>
        </div>
      </div>
    </div>
  </div>
</div>


<!-- pop up alert for signing  delete  -->
<div
  class="t-popup popup-patientDetails"
  style="display: block; z-index: 10000; position: fixed;"
  *ngIf="showSignEditAlert"
>
  <div class="t-popup-close"></div>

  <div class="t-popup-frame">
    <div class="t-popup-body">
      <button
        class="t-btn-popup-close"
        aria-label="close popup"
        (click)="showSignEditAlert = false"
      ></button>

      <h2 style="color: #d7a95b; font-size: xx-large;">
       <strong>Editing will void signature.</strong>
       <br />
      You will be prompted to re-sign.
       <br />
      <strong>Unsigned reports are not valid for printing or distribution.</strong>
	  <br />
	   For review only, use the <strong>View Only option.</strong>
    </h2>
      <div>
        <button class="blue-btn" (click)="hideButton = true; examService.isLoginForEdit = true; loginAsCurrentUser(true);
        checkLogin(true); examService.isLoginForEdit = true" >Continue Edit</button>
        <button
          class="orange-btn"
          style="margin-left: 2em"
           (click)="examService.isSignAndPrint = false; viewonly.emit()"
          
        >
          View Only
        </button>
      </div>
    </div>
  </div>
</div>
<!-- ======= popup alert(End) ======= -->
